'use client'
import { useState } from 'react'

import { wsMiddleware } from '../../graphql/client/middlewares'
import { WsConnectionStatus } from './use-ws-connection-status.types'

export const useWsConnectionStatus = (): WsConnectionStatus => {
  const [status, setStatus] = useState(WsConnectionStatus.waiting)

  let timeoutId: string | number | NodeJS.Timeout | undefined

  const resetTimeout = () => {
    clearTimeout(timeoutId)

    timeoutId = setTimeout(() => {
      setStatus(WsConnectionStatus.disconnected)
    }, 10000)
  }

  wsMiddleware().client.on('connecting', () => {
    setStatus(WsConnectionStatus.connecting)
  })

  wsMiddleware().client.on('connected', () => {
    setStatus(WsConnectionStatus.connected)
  })

  wsMiddleware().client.on('opened', () => {
    setStatus(WsConnectionStatus.opened)
  })

  wsMiddleware().client.on('closed', () => {
    setStatus(WsConnectionStatus.closed)
  })

  wsMiddleware().client.on('error', () => {
    setStatus(WsConnectionStatus.error)
  })

  wsMiddleware().client.on('message', (e) => {
    if (e.type === 'pong' || e.type === 'next') {
      resetTimeout()
      setStatus(WsConnectionStatus.heartbeat)
    }
  })

  return status
}
